// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1K0VT","title":"AfterBackImages_title__19gv0","images":"AfterBackImages_images__16e8l"};